export default __webpack_public_path__ + "static/media/icon-refund-order.08fbb050.svg";